import { type CoachingSessionStatus } from '@efdigital/ll-addon-data';
import { selectValue } from '@efdigital/ll-addon-ui/modifiers/select-value';
import {
  findSessionStatusGroup,
  isAllStatuses,
  isCustomStatuses,
  SESSION_STATUS_GROUPS,
} from '@efdigital/ll-admin-v2/utils/coaching/coaching-sessions/session-state';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';

interface SelectSessionStatusGroupSignature {
  Args: {
    values: CoachingSessionStatus[];
    onChange: (value: CoachingSessionStatus[]) => void;
  };
  Element: HTMLSelectElement;
}

export class SelectSessionStatusGroup extends Component<SelectSessionStatusGroupSignature> {
  onChange(selected: CoachingSessionStatus[]) {
    this.args.onChange(selected);
  }

  get selectedGroup() {
    return findSessionStatusGroup(this.args.values);
  }

  get selectedValue() {
    if (isAllStatuses(this.args.values)) {
      return '';
    }

    if (isCustomStatuses(this.args.values)) {
      return '--';
    }

    return this.selectedGroup?.label ?? '';
  }

  selectGroup = (event: Event) => {
    const selectedGroup = SESSION_STATUS_GROUPS.find(
      (group) => group.label === (event.target as HTMLSelectElement).value
    );
    if (selectedGroup) {
      this.args.onChange(selectedGroup.statuses);
    } else {
      this.args.onChange([]);
    }
  };

  <template>
    <select
      class="form-select"
      ...attributes
      {{selectValue this.selectedValue}}
      {{on "change" this.selectGroup}}
    >
      <option value="">All</option>
      {{#if @values.length}}
        {{#unless this.selectedGroup}}
          <option value="--">--</option>
        {{/unless}}
      {{/if}}
      {{#each SESSION_STATUS_GROUPS as |group|}}
        <option value={{group.label}}>{{group.label}}</option>
      {{/each}}
    </select>
  </template>
}
